import { breakpoints } from '../../styles/config';

const plasticSurgeryBreakpoint = breakpoints.laptop;
export default plasticSurgeryBreakpoint;
